import React from "react";
import DataGridTable from "../../../components/dataGridTable/DataGridTable";
import {
	ADD_NEW_ACTION,
	POOL_WEIGHT_CODE_MULTIPLIER_STATE_KEY,
	POOL_WEIGHT_SETTING_CODES_KEY,
	REMOVE_ACTION,
	TEXT_INPUT,
} from "../../../Consts";
import IRepertoireComponentDataItem from "../../../../redux/types/IRepertoireComponentDataItem";
import { ITabReduxItem } from "../../../../redux/types/ITabReduxItem";
import { updateUsagePoolField } from "../../../../redux/reducers/RepertoireReducer";
import { IRepertoireStateKeys } from "../../../types/IRepertoireStateKeys";
import { IUsagePoolStateKeys } from "../../../../redux/types/IUsagePoolState";
import {
	MessageBanner,
	MessageType,
} from "../../../components/messageBanner/MessageBanner";
import { IUsagePoolWeightCodeMultiplierDataItems } from "../../../types/usageTypes/IUsagePoolWeightCodeMultiplierDataItems";
import { IUsagePoolDatesAndDimensions } from "../../../types/usageTypes/IUsagePoolDatesAndDimensions";

const DUPLICATED_ROWS = "There are duplicated 'Code' values";

export interface IPoolWeightCodeMultiplierGridProps {
	selectedDimensionAndDateRange?: IUsagePoolDatesAndDimensions;
	isReadonly: boolean;
	activeTab?: number;
	tabs?: ITabReduxItem[];
	tableContents: IUsagePoolWeightCodeMultiplierDataItems[];
	componentInstance: string;
	dataGridTableData: IRepertoireComponentDataItem;
	incrementTempID?: () => void;
	updateUsagePoolField: typeof updateUsagePoolField;
}

export interface IPoolWeightCodeMultiplierGridState {
	loaded: boolean;
	validationMessages: string[];
}

export default class PoolWeightCodeMultiplierGrid extends React.Component<
	IPoolWeightCodeMultiplierGridProps,
	IPoolWeightCodeMultiplierGridState
> {
	constructor(props: IPoolWeightCodeMultiplierGridProps) {
		super(props);

		this.state = { loaded: false, validationMessages: [] };
	}

	componentDidMount() {
		this.setState({ loaded: true });
	}

	isValidDigit(char) {
		var charCodeZero = "0".charCodeAt(0);
		var charCodeNine = "9".charCodeAt(0);
		return (
			char.charCodeAt(0) >= charCodeZero &&
			char.charCodeAt(0) <= charCodeNine
		);
	}

	changeData = (value: any, name: IRepertoireStateKeys) => {
		const { updateUsagePoolField, tableContents, selectedDimensionAndDateRange } = this.props;

		if (!selectedDimensionAndDateRange) {
			return;
		}

		const currentValues = value.filter(
			(item) =>
				item.effectiveDateRange.value === selectedDimensionAndDateRange.effectiveDateRange
		);

		currentValues.forEach((item) => {
			if (
				item.weightMultiplier.value.length === 1 &&
				!this.isValidDigit(item.weightMultiplier.value)
			) {
				item.weightMultiplier.value = "";
			}
		});

		const updatedTableContents = (tableContents ?? [])
			.filter(
				(item) =>
					item.effectiveDateRange.value !== selectedDimensionAndDateRange.effectiveDateRange
			)
			.concat(currentValues);

		updateUsagePoolField(updatedTableContents, name as IUsagePoolStateKeys);

		const codes = currentValues.map((c) => c.codeValue.value);
		const hasDuplicates = new Set(codes).size !== codes.length;

		this.setState({
			validationMessages: hasDuplicates ? [DUPLICATED_ROWS] : [],
		});
	};

	getNewItem = (): IUsagePoolWeightCodeMultiplierDataItems | null => {
		const { selectedDimensionAndDateRange } = this.props;

		if (!selectedDimensionAndDateRange) {
			return null;
		}

		return {
			codeValue: { value: "", inputType: TEXT_INPUT },
			weightMultiplier: { value: "", inputType: TEXT_INPUT },
			poolDimensionsAndDatesID: selectedDimensionAndDateRange.poolDimensionsAndDatesID,
			effectiveDateRange: { value: selectedDimensionAndDateRange.effectiveDateRange, inputType: TEXT_INPUT }
		};
	};

	handleAdd = () => {
		const { incrementTempID, tableContents } = this.props;
		const newItem = this.getNewItem();

		if (!newItem) {
			return;
		}

		incrementTempID?.();

		this.changeData(
			[...(tableContents ?? []), newItem],
			POOL_WEIGHT_CODE_MULTIPLIER_STATE_KEY as IUsagePoolStateKeys
		);
	};

	resetMessageBanner = () => {
		this.setState({ validationMessages: [] });
	};

	getSelectedWeightCodeMultiplier = () => {
		const { tableContents, selectedDimensionAndDateRange } = this.props;

		if (!selectedDimensionAndDateRange) {
			return [];
		}

		return (tableContents ?? []).filter(
			(item) => item.effectiveDateRange.value === selectedDimensionAndDateRange.effectiveDateRange
		);
	};

	render() {
		const { loaded, validationMessages } = this.state;
		if (!loaded) return null;

		const {
			incrementTempID,
			dataGridTableData,
			tabs,
			activeTab,
			isReadonly,
			componentInstance,
		} = this.props;

		return (
			<div>
				{validationMessages.length > 0 && (
					<MessageBanner
						messages={validationMessages}
						messageType={MessageType.Danger}
						resetMessageBanner={this.resetMessageBanner.bind(this)}
					/>
				)}
				<DataGridTable
					customComponentOnClickAdd={this.handleAdd}
					tableContents={this.getSelectedWeightCodeMultiplier()}
					changeData={this.changeData.bind(this)}
					dataGridTableData={dataGridTableData}
					stateKey={componentInstance}
					componentInstance={componentInstance}
					showRowNumber={true}
					isReadOnly={isReadonly}
					tableActions={[
						{ name: ADD_NEW_ACTION },
						{ name: REMOVE_ACTION },
					]}
					tabs={tabs}
					activeTab={activeTab}
					incrementTempID={incrementTempID}
				/>
			</div>
		);
	}
}
